import React from 'react';
import ReactDOM from 'react-dom/client';
import Leanplum from 'leanplum-sdk';
import * as Sentry from '@sentry/react';
import { APP_INFO, IS_PROD, LEANPLUM_CONFIG, SENTRY_DNS } from 'config';
import EventReporter from 'lib/EventsProvider';
import './index.css';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

EventReporter.initialize();

if (IS_PROD) {
  Leanplum.setAppIdForProductionMode(LEANPLUM_CONFIG.APP_ID, LEANPLUM_CONFIG.KEY);
} else {
  Leanplum.setAppIdForDevelopmentMode(LEANPLUM_CONFIG.APP_ID, LEANPLUM_CONFIG.KEY);
}
Leanplum.start();
if (!IS_PROD) {
  window.Kinedu.Leanplum = Leanplum;
}

Sentry.init({
  dsn: SENTRY_DNS,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  environment: APP_INFO.Env,
  release: APP_INFO.version,
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  tracePropagationTargets: [/api.kinedu.com/],
  normalizeDepth: 3,

  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  // replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  // replaysOnErrorSampleRate: 1.0,
});


root.render(
  // <React.StrictMode>
  <App />,
  // </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
